// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"156":"e447bd3e","183":"d701fee6","348":"bc4433ef","708":"49f54013","910":"2fdbff2b"}[chunkId] + ".js";
};